import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private readonly defaultLang = 'fi';
  private readonly supportedLanguages = ['en', 'fi'];

  constructor(private translate: TranslateService) {
    // Set default language
    this.translate.setDefaultLang(this.defaultLang);

    // Try to get browser language or use default
    // const browserLang = this.translate.getBrowserLang();
    // const initialLang = browserLang && this.supportedLanguages.includes(browserLang) ? browserLang : this.defaultLang;
    const initialLang = this.defaultLang;

    this.useLanguage(initialLang);

    // Store the selected language in localStorage
    this.storeLanguage(initialLang);
  }

  /**
   * Gets the currently selected language
   */
  get currentLang(): string {
    return this.translate.currentLang || this.defaultLang;
  }

  /**
   * Gets all supported languages
   */
  get languages(): string[] {
    return this.supportedLanguages;
  }

  /**
   * Sets the language to use
   */
  useLanguage(lang: string): void {
    if (!this.supportedLanguages.includes(lang)) {
      lang = this.defaultLang;
    }

    this.translate.use(lang);
    this.storeLanguage(lang);
  }

  /**
   * Stores the selected language in localStorage
   */
  private storeLanguage(lang: string): void {
    localStorage.setItem('selectedLanguage', lang);
  }
}
